import { ForwardedRef, RefObject, useEffect, useMemo } from 'react';
import { useFormState } from 'react-hook-form';

import { useIpc } from '~src/utils/ipc-utils';

import { useAddressFormBusinessLogic } from '~address-form/context/use-address-form';
import { AddressFormFields } from '~address-form/types';

export const useFormFieldScroll = <T extends HTMLElement>(
  name: keyof AddressFormFields,
  ref: RefObject<T> | ForwardedRef<T>
) => {
  const ipc = useIpc();
  const { errors } = useFormState<AddressFormFields>();
  const { addressFormLayout, isModalForm } = useAddressFormBusinessLogic();
  const fieldOrder = useMemo(() => addressFormLayout.map(({ name }) => name), []);

  useEffect(() => {
    const fieldError = errors[name];
    const firstErroredField = fieldOrder.find(field => Object.keys(errors).includes(field));

    if (fieldError && name === firstErroredField) {
      if (ref && 'current' in ref) {
        if (isModalForm) {
          ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          const offsetValue = ref.current?.getBoundingClientRect().top;
          if (offsetValue) {
            ipc.send({
              name: 'scroll_widget',
              data: offsetValue,
            });
          }
        }
      }
    }
  }, [isModalForm, errors[name]]);
};
